import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import './style.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

import InstallBtn from '@cmps/InstallBtn/InstallBtn'
import request from 'request';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  draggable: true,
  fade: true,
};

// 小程序商店首页 轮播图
function App() {
  const fetch = useMemo(() => {
    const url = request.api.getBannerList;
    return request({
      type: 'GET',
      url,
    })
  }, [])

  let [fetchRes, setFetchRes] = useState(null)

  useEffect(() => {
    fetch.done(data => setFetchRes({data}))
    fetch.fail(err => setFetchRes({err}))

    return () => {
      setFetchRes = () => {}
    }
  }, [])

  const extCard = (data) => {
    return (
      <div className={classnames("slider-ext-card", {
        "show-info": data.type === 1
      })}>
        <img className="slider-img" src={data.bannerUrl}/>

        {
          data.type === 1 ? (
            <div className="ext-intro">
              <div className="ext-avatar-content">
                <img src={data.extLogo || ''}/>
              </div>

              <div className="ext-desc">
                <span className="ext-name">{data.extName || ``}</span>
                <span className="ext-detail">{data.extBrief || ``}</span>
              </div>

              <div className={"install-btn"} onClick={(e)=> {
                e.stopPropagation()
                console.log(`点击轮播图安装按钮`)
              }}>
                <InstallBtn
                  hadInstall={data.hadInstall}
                  isSlider={true}
                  extUuid={data.extUuid}
                  extName={data.extName || ''}
                />
              </div>
            </div>
          ) : null
        }

      </div>
    )
  }

  const elmLoading = null
  const elmErr = null;
  const elmSwiper =
    fetch.state() == "resolved" ? (
      <Slider
        {...settings}
      >
        {((fetchRes && fetchRes.data) || []).map((item, idx) => (
          <div key={`swiper-slider-${idx}`} onClick={(e) => {
            e.stopPropagation()
            console.log(`点击轮播图横幅:`, JSON.stringify(item.targetUrl));
            window.open(item.targetUrl)
          }}
          >
            {extCard(item, idx)}
          </div>
        ))}
      </Slider>
    ) : null;

  if (!(fetchRes && fetchRes.data)) return null;

  return (
    <div className={'slider-content'}>
      {elmLoading}
      {elmErr}
      {elmSwiper}
    </div>
  )
}

export default App